import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useOutlineSettings = () => {
    const [outline, setOutline] = useState({
        weight: 0,
        color: null,
    })
   
    const makFabric = useSelector((state: any) => state.makFabric)
   
    const handleChangeWeight = useCallback((weight) => {
        setOutline(prev => ({
            ...prev,
           weight
        }))
    },[])

    const handleSelectColor = useCallback(({color}) => {
        setOutline(prev => ({ ...prev, color }))
    },[])

    useEffect(() => {
        if (makFabric && outline.weight && outline.color) {
            makFabric.setFontOutline(makFabric.getSelectedText(), outline)
        }
    }, [makFabric, outline.weight, outline.color, outline])


    return{
        outline,
        changeColor : handleSelectColor,
        changeWeight: handleChangeWeight,
    }
}